<template lang="pug">
  .select-input(ref="select" :class="{'select-input--disabled': disabled}")
    label.select-input__label(
      v-if="label"
      :for="selectElementId"
      :class="labelClass"
    ) {{ label }}:
      .select-input__label-note(
        v-if="required"
      ) (required)
    .select-input__select-wrapper(v-if="isMobile")
      select.select-input__select(
        v-model="currentValue"
        :disabled="disabled"
        :id="selectElementId"
        :name="name"
        :required="required"
      )
        option(v-if="!required", :value="null") {{ defaultOption }}
        option(
          v-for="option in options"
          :value="option.value"
          :key="option.value"
          :disabled="option.disabled"
        ) {{ option.label }}
      icon.select-input__icon(name="chevron-down", size="24px")
    v-select(v-else :options="options" :searchable="false" :disabled="disabled" v-model="currentValue")
      template(v-slot:open-indicator="openIndciatorAttributes")
        span(v-bind="openIndciatorAttributes")
          icon.select-input__icon(name="chevron-down", size="24px")
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';
  import vSelect from 'vue-select';

  export default {
    components: {
      Icon,
      vSelect,
    },
    props: {
      name: String,
      id: String,
      label: String,
      placeholder: String,
      options: {
        type: Array,
        default: () => [],
      },
      selected: {
        type: String,
        default: null,
      },
      hideLabel: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      required: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        currentValue: this.selected ? this.selected : this.required ? this.options[0].value : null,
        openIndciatorAttributes: {
          ref: 'openIndicator',
          role: 'presentation',
          class: 'vs__open-indicator',
        },
      };
    },
    computed: {
      selectElementId() {
        return this.id || `select_${this._uid}`;
      },
      defaultOption() {
        return this.placeholder !== '' ? this.placeholder : '';
      },
      labelClass() {
        return {
          'u-sr-only': this.hideLabel,
        };
      },
      isMobile() {
        return ['mobile', 'tablet'].includes(this.$mq);
      },
    },
    watch: {
      currentValue() {
        this.$emit('input', this.currentValue);
      },
    },
    mounted() {
      this.$emit('input', this.currentValue);
    },
  };
</script>
